const ESTATE_THRESHOLDS: Record<string, number> = {
  AL: 47000,
  AK: 50000,
  AZ: 200000,
  AR: 100000,
  CA: 208850,
  CO: 88000,
  CT: 40000,
  DE: 50000,
  FL: 150000,
  GA: 15000,
  HI: 100000,
  ID: 100000,
  IL: 150000,
  IN: 100000,
  IA: 100000,
  KS: 75000,
  KY: 30000,
  LA: 200000,
  ME: 52500,
  MD: 50000,
  MA: 25000,
  MI: 53000,
  MN: 75000,
  MS: 75000,
  MO: 40000,
  MT: 100000,
  NE: 100000,
  NV: 25000,
  NH: 50000,
  NJ: 50000,
  NM: 50000,
  NY: 50000,
  NC: 20000,
  ND: 100000,
  OH: 35000,
  OK: 50000,
  OR: 75000,
  PA: 50000,
  RI: 15000,
  SC: 45000,
  SD: 100000,
  TN: 50000,
  TX: 75000,
  UT: 100000,
  VT: 45000,
  VA: 75000,
  WA: 100000,
  DC: 80000,
  WV: 50000,
  WI: 50000,
  WY: 400000,
};

const DEFAULT_THRESHOLD = 50000;

export function getEstateThreshold(stateAbbreviation: string | null | undefined): number {
  if (!stateAbbreviation) return DEFAULT_THRESHOLD;
  return ESTATE_THRESHOLDS[stateAbbreviation.toUpperCase()] ?? DEFAULT_THRESHOLD;
}
